import React from 'react'

export default function UserLogs() {
  return (
    <div>UserLogs</div>
  )
}
